export const isBrowser = () => typeof window !== "undefined"
export const isDataLayer = () => typeof window?.dataLayer !== "undefined"
